module.exports = __webpack_public_path__ + "img/a26.46c70db3.svg";